import { render, staticRenderFns } from "./TheRegattaFoundation.vue?vue&type=template&id=0d0bdd47&scoped=true&"
import script from "./TheRegattaFoundation.vue?vue&type=script&lang=js&"
export * from "./TheRegattaFoundation.vue?vue&type=script&lang=js&"
import style0 from "./TheRegattaFoundation.vue?vue&type=style&index=0&id=0d0bdd47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0bdd47",
  null
  
)

export default component.exports